// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"3daa5644","856":"f2241145","952":"eabc4714"}[chunkId] + ".chunk.js";
};